// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:25
import { CustomCallCard_abstract } from './../abstract/SagaSchema/CustomCallCard_abstract';
export class CustomCallCard extends CustomCallCard_abstract {}
